/** @file Edit-mesh tool options: click mode (modify/create/delete), id labels, keep image in place. */
import { createStore } from 'zustand/vanilla';

/** What a click does: select and drag vertices, add a vertex, or delete the vertex under the pointer. */
export type EditMeshMode = 'modify' | 'create' | 'delete';

/** Tool options shown in the Weights panel's mesh section. */
export interface EditMeshOptions {
  mode: EditMeshMode;
  showIds: boolean;
  /** Setup drags move uvs with the vertices so the image stays put (false: the image stretches). */
  keepImage: boolean;
}

/** Starts in modify mode, no id labels, image kept in place. */
export const editMeshStore = createStore<EditMeshOptions>()(() => ({ mode: 'modify', showIds: false, keepImage: true }));
